const ROOT = 'dashboard/buildings';

export default {
	arrayList: `${ROOT}/list`,
	arrayListToDropdown: `${ROOT}`,
	store: `${ROOT}`,
	show: `${ROOT}/`,
	update: `${ROOT}/`,
	destroy: `${ROOT}/`,
};
